module.exports = __webpack_public_path__ + "img/share-twitter.5540fdda.svg";